var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useCallback, useEffect } from 'react';
var useTrolleyActions = function (_a, uoms) {
    var trolleyAmount = _a.amount, trolleyUomId = _a.uomId;
    var _b = useState({
        amount: (trolleyAmount || uoms[trolleyUomId].increment).toString(),
        uomId: trolleyUomId,
    }), desiredQuantity = _b[0], setDesiredQuantity = _b[1];
    var _c = useState(false), isEditingTrolleyAmount = _c[0], setEditingTrolleyAmount = _c[1];
    var isProductInTrolley = !!trolleyAmount;
    useEffect(function () {
        if (!isEditingTrolleyAmount) {
            if (isProductInTrolley) {
                setDesiredQuantity({
                    amount: trolleyAmount,
                    uomId: trolleyUomId,
                });
            }
            else {
                setDesiredQuantity({
                    amount: uoms[trolleyUomId].increment,
                    uomId: trolleyUomId,
                });
            }
        }
    }, [isProductInTrolley, isEditingTrolleyAmount, trolleyAmount, trolleyUomId, uoms]);
    var selectDesiredUom = useCallback(function (uomId) {
        var isSameUomAsTrolley = trolleyUomId === uomId;
        setEditingTrolleyAmount(!isSameUomAsTrolley);
        setDesiredQuantity({
            amount: isSameUomAsTrolley && trolleyAmount ? trolleyAmount : uoms[uomId].increment,
            uomId: uomId,
        });
    }, [uoms, trolleyAmount, trolleyUomId]);
    var updateDesiredAmount = useCallback(function (desiredAmount) {
        setEditingTrolleyAmount(!(+desiredAmount > 0 && desiredAmount === trolleyAmount));
        setDesiredQuantity(__assign(__assign({}, desiredQuantity), { amount: desiredAmount }));
    }, [trolleyAmount, desiredQuantity]);
    return {
        desiredAmount: desiredQuantity.amount,
        desiredUomId: desiredQuantity.uomId,
        selectDesiredUom: selectDesiredUom,
        updateDesiredAmount: updateDesiredAmount,
        isEditingTrolleyAmount: isEditingTrolleyAmount,
        setEditingTrolleyAmount: setEditingTrolleyAmount,
    };
};
export default useTrolleyActions;
//# sourceMappingURL=use-trolley-actions.js.map